// src/components/admin/HeroEditor.js
import React, { useState } from 'react';
import './EditorStyles.css';

const HeroEditor = () => {
  const [heroData, setHeroData] = useState({
    headline: "Welcome to Our Website",
    subheading: "We provide top-notch services for your business",
    ctaText: "Get Started",
    ctaLink: "#contact",
    backgroundImage: "/path/to/hero-bg.jpg",
    textColor: "#ffffff",
    overlayColor: "rgba(0, 0, 0, 0.5)",
    overlayOpacity: 50
  });
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setHeroData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleOpacityChange = (e) => {
    const opacity = parseInt(e.target.value);
    const rgba = `rgba(0, 0, 0, ${opacity / 100})`;
    
    setHeroData(prev => ({
      ...prev,
      overlayOpacity: opacity,
      overlayColor: rgba
    }));
  };
  
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Preview the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setHeroData(prev => ({
          ...prev,
          backgroundImage: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would send the updated data to your backend
    console.log("Saving hero data:", heroData);
    alert("Hero section updated successfully!");
  };
  
  return (
    <div className="section-editor">
      <h2>Edit Hero Section</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Headline</label>
          <input 
            type="text" 
            name="headline"
            value={heroData.headline}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-group">
          <label>Subheading</label>
          <input 
            type="text" 
            name="subheading"
            value={heroData.subheading}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>CTA Button Text</label>
            <input 
              type="text" 
              name="ctaText"
              value={heroData.ctaText}
              onChange={handleInputChange}
            />
          </div>
          
          <div className="form-group">
            <label>CTA Button Link</label>
            <input 
              type="text" 
              name="ctaLink"
              value={heroData.ctaLink}
              onChange={handleInputChange}
            />
          </div>
        </div>
        
        <div className="form-group">
          <label>Text Color</label>
          <div className="color-picker-group">
            <input 
              type="color" 
              name="textColor"
              value={heroData.textColor}
              onChange={handleInputChange}
            />
            <span>{heroData.textColor}</span>
          </div>
        </div>
        
        <div className="form-group">
          <label>Overlay Opacity ({heroData.overlayOpacity}%)</label>
          <input 
            type="range" 
            min="0" 
            max="100" 
            value={heroData.overlayOpacity}
            onChange={handleOpacityChange}
          />
          <div 
            className="overlay-preview" 
            style={{ 
              backgroundColor: heroData.overlayColor,
              width: '100%',
              height: '20px',
              borderRadius: '4px'
            }}
          ></div>
        </div>
        
        <div className="form-group">
          <label>Background Image</label>
          <div className="image-preview" style={{ height: '150px' }}>
            <img 
              src={heroData.backgroundImage} 
              alt="Hero background" 
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'cover' 
              }} 
            />
          </div>
          <input 
            type="file" 
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>
        
        <div className="text-preview" style={{ color: heroData.textColor }}>
          <h3>{heroData.headline}</h3>
          <p>{heroData.subheading}</p>
          <button className="preview-cta">{heroData.ctaText}</button>
        </div>
        
        <button type="submit" className="save-button">Save Changes</button>
      </form>
    </div>
  );
};

export default HeroEditor;